import classNames from "classnames";
import { useCallback, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { FaUserCircle } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { NavLink } from "react-router";
import { LogoutIcon } from "../../../../../assets";
import { EXTERNAL_LOGIN_URL } from "../../../../consts";
import { doLogout } from "../../../../store/reducer/_sessionReducer";
import { getLoggedIn, getLoggedUser } from "../../../../store/selectors";
import { PDLTypography } from "../../dna";
import "./index.scss";

interface UserDetailsProps {
  triggerVariant?: "default" | "white";
}

const UserDetails = ({ triggerVariant = "default" }: UserDetailsProps) => {
  const dispatch = useDispatch();
  const loggedUser = useSelector(getLoggedUser);
  const loggedIn = useSelector(getLoggedIn);

  const [showModal, setShowModal] = useState(false);

  const handleOpen = useCallback(() => {
    setShowModal(true);
  }, []);

  const handleClose = useCallback(() => {
    setShowModal(false);
  }, []);

  const redirectToLogin = useCallback(() => {
    window.location.href = EXTERNAL_LOGIN_URL;
  }, []);

  const handleLogout = useCallback(async () => {
    await dispatch(doLogout());
    redirectToLogin();
  }, [dispatch, redirectToLogin]);

  return (
    <div className="pdl_component_userdetails">
      {loggedIn ? (
        <>
          <button
            className={classNames(
              "userdetails-trigger",
              triggerVariant === "default"
                ? "userdetails-trigger-default"
                : "userdetails-trigger-white",
            )}
            onClick={handleOpen}
            aria-label="Abrir detalhes do usuario"
          >
            <FaUserCircle size="40" />
          </button>

          <Modal
            show={showModal}
            onHide={handleClose}
            contentClassName="h-100 d-flex flex-column align-items-stretch justify-content-between gap-4"
            dialogClassName="h-100"
            className="pdl_component_userdetails_modal d-flex flex-row align-items-stretch justify-content-end"
          >
            <Modal.Header closeButton>
              <Modal.Title className="userdetails-modal-title">
                <PDLTypography display size="xl" variant="semibold">
                  Minha conta
                </PDLTypography>
                <PDLTypography size="sm" variant="regular">
                  Veja os detalhes de sua conta
                </PDLTypography>
              </Modal.Title>
            </Modal.Header>

            <Modal.Body className="userdetails-modal-body">
              <div className="userdetails-info">
                <div className="userdetails-avatar">
                  <FaUserCircle size="64" />
                </div>
                <div className="userdetails-data">
                  <span className="userdetails-name">{loggedUser?.name}</span>
                  <span className="userdetails-email">{loggedUser?.email}</span>
                </div>
              </div>

              <nav className="userdetails-nav d-flex flex-column justify-content-between h-100">
                <NavLink
                  to="/perfil"
                  className="userdetails-nav-link"
                  onClick={handleClose}
                >
                  Conteúdos salvos
                </NavLink>
                <div className="userdetails-nav-divider">
                  <NavLink
                    to="/sobre"
                    className="userdetails-nav-link"
                    onClick={handleClose}
                  >
                    Sobre
                  </NavLink>
                </div>
              </nav>
            </Modal.Body>

            <Modal.Footer className="userdetails-modal-footer">
              <button className="userdetails-logout-btn" onClick={handleLogout}>
                <LogoutIcon />
                <p> Sair</p>
              </button>
            </Modal.Footer>
          </Modal>
        </>
      ) : (
        <FaUserCircle size="48" />
      )}
    </div>
  );
};

export default UserDetails;
